<template>
	<div class="orders-form-container">
		<!-- 页面头部 -->
		<div class="page-header">
			<div class="header-left">
				<el-button type="text" @click="back()" class="back-button">
					<i class="el-icon-arrow-left"></i>
					返回
				</el-button>
				<div class="header-info">
					<h1>{{ id ? (type === 'info' ? '订单详情' : (type === 'logistics' ? '物流管理' : '编辑订单')) : '新建订单' }}</h1>
					<div class="breadcrumb">
						<span>订单管理</span>
						<i class="el-icon-arrow-right"></i>
						<span>{{ id ? (type === 'info' ? '订单详情' : (type === 'logistics' ? '物流管理' : '编辑订单')) : '新建订单' }}</span>
					</div>
				</div>
			</div>
			<div class="header-actions" v-if="type !== 'info'">
				<el-button @click="back()">取消</el-button>
				<el-button type="primary" @click="onSubmit" :loading="submitLoading">
					{{ type === 'logistics' ? '更新物流' : '保存订单' }}
				</el-button>
			</div>
			<div class="header-actions" v-else>
				<el-button type="primary" @click="back()">返回列表</el-button>
			</div>
		</div>

		<!-- 表单内容 -->
		<div class="form-content">
			<el-form
				ref="ruleForm"
				:model="ruleForm"
				:rules="rules"
				label-width="140px"
				class="order-form"
			>
				<!-- 订单基本信息 -->
				<div v-if="logistics" class="form-section">
					<div class="section-title">
						<div class="title-icon">
							<svg viewBox="0 0 24 24">
								<path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
							</svg>
						</div>
						<span>订单基本信息</span>
					</div>
					
					<el-form-item label="订单编号" prop="orderid" class="form-item">
						<div class="input-wrapper">
							<div class="input-field">
								<div class="field-icon">
									<svg viewBox="0 0 24 24">
										<path d="M14,2H6A2,2 0 0,0 4,4V20A2,2 0 0,0 6,22H18A2,2 0 0,0 20,20V8L14,2M18,20H6V4H13V9H18V20Z"/>
									</svg>
								</div>
								<el-input v-model="ruleForm.orderid" placeholder="订单编号" :readonly="true" class="form-input"></el-input>
								<div class="readonly-indicator" v-if="true">
									<i class="el-icon-lock"></i>
								</div>
							</div>
							<div class="field-tip">系统自动生成的唯一订单编号</div>
						</div>
					</el-form-item>

					<el-form-item label="商品名称" prop="goodname" class="form-item">
						<div class="input-wrapper">
							<div class="input-field">
								<div class="field-icon">
									<svg viewBox="0 0 24 24">
										<path d="M12,15.5A3.5,3.5 0 0,1 8.5,12A3.5,3.5 0 0,1 12,8.5A3.5,3.5 0 0,1 15.5,12A3.5,3.5 0 0,1 12,15.5M19.43,12.97C19.47,12.65 19.5,12.33 19.5,12C19.5,11.67 19.47,11.34 19.43,11.03L21.54,9.37C21.73,9.22 21.78,8.95 21.66,8.73L19.66,5.27C19.54,5.05 19.27,4.96 19.05,5.05L16.56,6.05C16.04,5.66 15.5,5.32 14.87,5.07L14.5,2.42C14.46,2.18 14.25,2 14,2H10C9.75,2 9.54,2.18 9.5,2.42L9.13,5.07C8.5,5.32 7.96,5.66 7.44,6.05L4.95,5.05C4.73,4.96 4.46,5.05 4.34,5.27L2.34,8.73C2.22,8.95 2.27,9.22 2.46,9.37L4.57,11.03C4.53,11.34 4.5,11.67 4.5,12C4.5,12.33 4.53,12.65 4.57,12.97L2.46,14.63C2.27,14.78 2.22,15.05 2.34,15.27L4.34,18.73C4.46,18.95 4.73,19.03 4.95,18.95L7.44,17.94C7.96,18.34 8.5,18.68 9.13,18.93L9.5,21.58C9.54,21.82 9.75,22 10,22H14C14.25,22 14.46,21.82 14.5,21.58L14.87,18.93C15.5,18.68 16.04,18.34 16.56,17.94L19.05,18.95C19.27,19.03 19.54,18.95 19.66,18.73L21.66,15.27C21.78,15.05 21.73,14.78 21.54,14.63L19.43,12.97Z"/>
									</svg>
								</div>
								<el-input v-model="ruleForm.goodname" placeholder="商品名称" :readonly="ro.goodname || type === 'info'" class="form-input"></el-input>
								<div class="readonly-indicator" v-if="ro.goodname || type === 'info'">
									<i class="el-icon-lock"></i>
								</div>
							</div>
							<div class="field-tip">订单中的商品名称</div>
						</div>
					</el-form-item>

					<el-form-item label="商品类型" prop="goodtype" class="form-item">
						<div class="input-wrapper">
							<div class="input-field">
								<div class="field-icon">
									<svg viewBox="0 0 24 24">
										<path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"/>
									</svg>
								</div>
								<el-input v-model="ruleForm.goodtype" placeholder="商品类型" :readonly="ro.goodtype || type === 'info'" class="form-input"></el-input>
								<div class="readonly-indicator" v-if="ro.goodtype || type === 'info'">
									<i class="el-icon-lock"></i>
								</div>
							</div>
							<div class="field-tip">商品所属的类型分类</div>
						</div>
					</el-form-item>
				</div>

				<!-- 商品图片 -->
				<div v-if="logistics" class="form-section">
					<div class="section-title">
						<div class="title-icon">
							<svg viewBox="0 0 24 24">
								<path d="M8.5,13.5L11,16.5L14.5,12L19,18H5M21,19V5C21,3.89 20.1,3 19,3H5A2,2 0 0,0 3,5V19A2,2 0 0,0 5,21H19A2,2 0 0,0 21,19Z"/>
							</svg>
						</div>
						<span>商品图片</span>
					</div>

					<el-form-item label="商品图片" prop="picture" class="form-item image-item">
						<div class="image-upload-wrapper" v-if="type !== 'info' && !ro.picture">
							<file-upload
								tip="点击上传商品图片"
								action="file/upload"
								:limit="3"
								:multiple="true"
								:fileUrls="ruleForm.picture ? ruleForm.picture : ''"
								@change="pictureUploadChange"
							></file-upload>
							<div class="upload-tips">
								<p>• 支持JPG、PNG格式</p>
								<p>• 建议尺寸：800x600像素</p>
								<p>• 文件大小不超过2MB</p>
							</div>
						</div>
						<div class="image-preview" v-else-if="ruleForm.picture">
							<div class="image-gallery">
								<template v-if="ruleForm.picture.substring(0,4)==='http'">
									<div class="preview-item">
										<img :src="ruleForm.picture.split(',')[0]" class="preview-img" @click="previewImage(ruleForm.picture.split(',')[0])">
										<div class="image-actions">
											<i class="el-icon-zoom-in" @click="previewImage(ruleForm.picture.split(',')[0])"></i>
										</div>
									</div>
								</template>
								<template v-else>
									<div v-for="(item, index) in ruleForm.picture.split(',')" :key="index" class="preview-item">
										<img :src="$base.url + item" class="preview-img" @click="previewImage($base.url + item)">
										<div class="image-actions">
											<i class="el-icon-zoom-in" @click="previewImage($base.url + item)"></i>
										</div>
									</div>
								</template>
							</div>
						</div>
						<div class="empty-image" v-else>
							<i class="el-icon-picture-outline"></i>
							<span>暂无商品图片</span>
						</div>
					</el-form-item>
				</div>

				<!-- 数量价格信息 -->
				<div v-if="logistics" class="form-section">
					<div class="section-title">
						<div class="title-icon">
							<svg viewBox="0 0 24 24">
								<path d="M7,15H9C9,16.08 10.37,17 12,17C13.63,17 15,16.08 15,15C15,13.9 13.96,13.5 11.76,12.97C9.64,12.44 7,11.78 7,9C7,7.21 8.47,5.69 10.5,5.18V3H13.5V5.18C15.53,5.69 17,7.21 17,9H15C15,7.92 13.63,7 12,7C10.37,7 9,7.92 9,9C9,10.1 10.04,10.5 12.24,11.03C14.36,11.56 17,12.22 17,15C17,16.79 15.53,18.31 13.5,18.82V21H10.5V18.82C8.47,18.31 7,16.79 7,15Z"/>
							</svg>
						</div>
						<span>数量价格信息</span>
					</div>

					<div class="form-row">
						<el-form-item label="购买数量" prop="buynumber" class="form-item">
							<div class="input-wrapper">
								<div class="input-field">
									<div class="field-icon">
										<svg viewBox="0 0 24 24">
											<path d="M12,2C13.1,2 14,2.9 14,4C14,5.1 13.1,6 12,6C10.9,6 10,5.1 10,4C10,2.9 10.9,2 12,2M21,9V7L15,1H5C3.89,1 3,1.89 3,3V21A2,2 0 0,0 5,23H19A2,2 0 0,0 21,21V9H21M19,19H5V3H13V9H19V19Z"/>
										</svg>
									</div>
									<el-input v-model="ruleForm.buynumber" placeholder="购买数量" :readonly="ro.buynumber || type === 'info'" class="form-input"></el-input>
									<div class="readonly-indicator" v-if="ro.buynumber || type === 'info'">
										<i class="el-icon-lock"></i>
									</div>
								</div>
								<div class="field-tip">客户购买的商品数量</div>
							</div>
						</el-form-item>

						<el-form-item label="商品价格" prop="price" class="form-item">
							<div class="input-wrapper">
								<div class="input-field">
									<div class="field-icon">¥</div>
									<el-input v-model="ruleForm.price" placeholder="商品价格" :readonly="ro.price || type === 'info'" class="form-input"></el-input>
									<div class="readonly-indicator" v-if="ro.price || type === 'info'">
										<i class="el-icon-lock"></i>
									</div>
								</div>
								<div class="field-tip">商品的单价</div>
							</div>
						</el-form-item>
					</div>

					<div class="form-row">
						<el-form-item label="折扣价格" prop="discountprice" class="form-item">
							<div class="input-wrapper">
								<div class="input-field">
									<div class="field-icon">¥</div>
									<el-input v-model="ruleForm.discountprice" placeholder="折扣价格" :readonly="ro.discountprice || type === 'info'" class="form-input"></el-input>
									<div class="readonly-indicator" v-if="ro.discountprice || type === 'info'">
										<i class="el-icon-lock"></i>
									</div>
								</div>
								<div class="field-tip">优惠后的商品单价</div>
							</div>
						</el-form-item>

						<el-form-item label="总价格" prop="total" class="form-item">
							<div class="input-wrapper">
								<div class="input-field">
									<div class="field-icon">¥</div>
									<el-input v-model="ruleForm.total" placeholder="总价格" :readonly="ro.total || type === 'info'" class="form-input"></el-input>
									<div class="readonly-indicator" v-if="ro.total || type === 'info'">
										<i class="el-icon-lock"></i>
									</div>
								</div>
								<div class="field-tip">商品数量 × 单价</div>
							</div>
						</el-form-item>
					</div>

					<el-form-item label="折扣总价格" prop="discounttotal" class="form-item">
						<div class="input-wrapper">
							<div class="input-field">
								<div class="field-icon">¥</div>
								<el-input v-model="ruleForm.discounttotal" placeholder="折扣总价格" :readonly="ro.discounttotal || type === 'info'" class="form-input"></el-input>
								<div class="readonly-indicator" v-if="ro.discounttotal || type === 'info'">
									<i class="el-icon-lock"></i>
								</div>
							</div>
							<div class="field-tip">优惠后的总价格，实际支付金额</div>
						</div>
					</el-form-item>
				</div>

				<!-- 支付状态信息 -->
				<div v-if="logistics" class="form-section">
					<div class="section-title">
						<div class="title-icon">
							<svg viewBox="0 0 24 24">
								<path d="M20,8H4V6H20M20,18H4V12H20M22,18V6C22,4.89 21.1,4 20,4H4C2.9,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20C21.1,20 22,19.1 22,18Z"/>
							</svg>
						</div>
						<span>支付状态信息</span>
					</div>

					<div class="form-row">
						<el-form-item label="支付类型" prop="type" class="form-item">
							<div class="select-wrapper" v-if="type !== 'info'">
								<div class="select-field">
									<div class="field-icon">
										<svg viewBox="0 0 24 24">
											<path d="M20,8H4V6H20M20,18H4V12H20M22,18V6C22,4.89 21.1,4 20,4H4C2.9,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20C21.1,20 22,19.1 22,18Z"/>
										</svg>
									</div>
									<el-select v-model="ruleForm.type" placeholder="请选择支付类型" :disabled="ro.type" class="form-select">
										<el-option v-for="(item, index) in typeOptions" :key="index" :label="item" :value="index + 1"></el-option>
									</el-select>
								</div>
								<div class="field-tip">客户选择的支付方式</div>
							</div>
							<div class="input-wrapper" v-else>
								<div class="input-field">
									<div class="field-icon">
										<svg viewBox="0 0 24 24">
											<path d="M20,8H4V6H20M20,18H4V12H20M22,18V6C22,4.89 21.1,4 20,4H4C2.9,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20C21.1,20 22,19.1 22,18Z"/>
										</svg>
									</div>
									<el-input :value="getPaymentTypeText(ruleForm.type)" placeholder="支付类型" readonly class="form-input"></el-input>
									<div class="readonly-indicator">
										<i class="el-icon-lock"></i>
									</div>
								</div>
								<div class="field-tip">客户选择的支付方式</div>
							</div>
						</el-form-item>

						<el-form-item label="订单状态" prop="status" class="form-item">
							<div class="select-wrapper" v-if="type !== 'info'">
								<div class="select-field">
									<div class="field-icon">
										<svg viewBox="0 0 24 24">
											<path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M10,17L5,12L6.41,10.59L10,14.17L17.59,6.58L19,8L10,17Z"/>
										</svg>
									</div>
									<el-select v-model="ruleForm.status" placeholder="请选择状态" :disabled="ro.status" class="form-select">
										<el-option v-for="(item, index) in statusOptions" :key="index" :label="item" :value="item"></el-option>
									</el-select>
								</div>
								<div class="field-tip">当前订单的处理状态</div>
							</div>
							<div class="input-wrapper" v-else>
								<div class="input-field">
									<div class="field-icon">
										<svg viewBox="0 0 24 24">
											<path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M10,17L5,12L6.41,10.59L10,14.17L17.59,6.58L19,8L10,17Z"/>
										</svg>
									</div>
									<el-input v-model="ruleForm.status" placeholder="订单状态" readonly class="form-input"></el-input>
									<div class="readonly-indicator">
										<i class="el-icon-lock"></i>
									</div>
								</div>
								<div class="field-tip">当前订单的处理状态</div>
							</div>
						</el-form-item>
					</div>
				</div>

				<!-- 收货信息 -->
				<div v-if="logistics" class="form-section">
					<div class="section-title">
						<div class="title-icon">
							<svg viewBox="0 0 24 24">
								<path d="M12,11.5A2.5,2.5 0 0,1 9.5,9A2.5,2.5 0 0,1 12,6.5A2.5,2.5 0 0,1 14.5,9A2.5,2.5 0 0,1 12,11.5M12,2A7,7 0 0,0 5,9C5,14.25 12,22 12,22C12,22 19,14.25 19,9A7,7 0 0,0 12,2Z"/>
							</svg>
						</div>
						<span>收货信息</span>
					</div>

					<el-form-item label="收货人" prop="consignee" class="form-item">
						<div class="input-wrapper">
							<div class="input-field">
								<div class="field-icon">
									<svg viewBox="0 0 24 24">
										<path d="M12,4A4,4 0 0,1 16,8A4,4 0 0,1 12,12A4,4 0 0,1 8,8A4,4 0 0,1 12,4M12,14C16.42,14 20,15.79 20,18V20H4V18C4,15.79 7.58,14 12,14Z"/>
									</svg>
								</div>
								<el-input v-model="ruleForm.consignee" placeholder="收货人姓名" :readonly="ro.consignee || type === 'info'" class="form-input"></el-input>
								<div class="readonly-indicator" v-if="ro.consignee || type === 'info'">
									<i class="el-icon-lock"></i>
								</div>
							</div>
							<div class="field-tip">接收商品的联系人姓名</div>
						</div>
					</el-form-item>

					<el-form-item label="联系电话" prop="tel" class="form-item">
						<div class="input-wrapper">
							<div class="input-field">
								<div class="field-icon">
									<svg viewBox="0 0 24 24">
										<path d="M6.62,10.79C8.06,13.62 10.38,15.94 13.21,17.38L15.41,15.18C15.69,14.9 16.08,14.82 16.43,14.93C17.55,15.3 18.75,15.5 20,15.5A1,1 0 0,1 21,16.5V20A1,1 0 0,1 20,21A17,17 0 0,1 3,4A1,1 0 0,1 4,3H7.5A1,1 0 0,1 8.5,4C8.5,5.25 8.7,6.45 9.07,7.57C9.18,7.92 9.1,8.31 8.82,8.59L6.62,10.79Z"/>
									</svg>
								</div>
								<el-input v-model="ruleForm.tel" placeholder="收货人联系电话" :readonly="ro.tel || type === 'info'" class="form-input"></el-input>
								<div class="readonly-indicator" v-if="ro.tel || type === 'info'">
									<i class="el-icon-lock"></i>
								</div>
							</div>
							<div class="field-tip">收货人的联系电话</div>
						</div>
					</el-form-item>

					<el-form-item label="收货地址" prop="address" class="form-item">
						<div class="textarea-wrapper">
							<div class="textarea-field">
								<div class="field-icon">
									
								</div>
								<el-input type="textarea" v-model="ruleForm.address" placeholder="详细收货地址" :readonly="ro.address || type === 'info'" class="form-textarea" :rows="3"></el-input>
								<div class="readonly-indicator" v-if="ro.address || type === 'info'">
									<i class="el-icon-lock"></i>
								</div>
							</div>
						</div>
					</el-form-item>

					<el-form-item label="订单备注" prop="remark" class="form-item">
						<div class="textarea-wrapper">
							<div class="textarea-field">
								<div class="field-icon">
									
								</div>
								<el-input type="textarea" v-model="ruleForm.remark" placeholder="订单相关备注信息" :readonly="ro.remark || type === 'info'" class="form-textarea" :rows="3"></el-input>
								<div class="readonly-indicator" v-if="ro.remark || type === 'info'">
									<i class="el-icon-lock"></i>
								</div>
							</div>
							<div class="field-tip">客户留言或特殊要求</div>
						</div>
					</el-form-item>

					<el-form-item label="下单时间" prop="addtime" class="form-item" v-if="type === 'info'">
						<div class="input-wrapper">
							<div class="input-field">
								<div class="field-icon">
									<svg viewBox="0 0 24 24">
										<path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.7L16.2,16.2Z"/>
									</svg>
								</div>
								<el-input v-model="ruleForm.addtime" placeholder="下单时间" readonly class="form-input"></el-input>
								<div class="readonly-indicator">
									<i class="el-icon-lock"></i>
								</div>
							</div>
							<div class="field-tip">客户提交订单的时间</div>
						</div>
					</el-form-item>
				</div>

				<!-- 物流信息 -->
				<div class="form-section">
					<div class="section-title">
						<div class="title-icon">
							<svg viewBox="0 0 24 24">
								<path d="M18,18.5A1.5,1.5 0 0,1 16.5,17A1.5,1.5 0 0,1 18,15.5A1.5,1.5 0 0,1 19.5,17A1.5,1.5 0 0,1 18,18.5M19.5,9.5L21.46,12H17V9.5M6,18.5A1.5,1.5 0 0,1 4.5,17A1.5,1.5 0 0,1 6,15.5A1.5,1.5 0 0,1 7.5,17A1.5,1.5 0 0,1 6,18.5M20,8H17V4H3C1.89,4 1,4.89 1,6V17H3A3,3 0 0,0 6,20A3,3 0 0,0 9,17H15A3,3 0 0,0 18,20A3,3 0 0,0 21,17H23V12L20,8Z"/>
							</svg>
						</div>
						<span>物流信息</span>
					</div>

					<el-form-item label="物流详情" prop="logistics" class="form-item content-item">
						<div class="editor-wrapper" v-if="type !== 'info'">
							<editor 
								v-model="ruleForm.logistics" 
								class="content-editor"
								action="file/upload"
								style="min-width: 200px; max-width: 600px;"
							></editor>
							<div class="field-tip">详细的物流跟踪信息，支持富文本编辑</div>
						</div>
						<div class="content-preview" v-else-if="ruleForm.logistics">
							<div class="content-html" v-html="ruleForm.logistics"></div>
						</div>
						<div class="empty-content" v-else>
							<i class="el-icon-document"></i>
							<span>暂无物流信息</span>
						</div>
					</el-form-item>
				</div>
			</el-form>
		</div>

		<!-- 图片预览对话框 -->
		<el-dialog 
			title="图片预览" 
			:visible.sync="previewVisible" 
			width="600px"
			class="preview-dialog"
		>
			<img :src="previewImageUrl" style="width: 100%; height: auto;">
		</el-dialog>
	</div>
</template>
<script>
// 数字，邮件，手机，url，身份证校验
import { isNumber,isIntNumer,isEmail,isPhone, isMobile,isURL,checkIdCard } from "@/utils/validate";
export default {
	data() {
		let self = this
		var validateIdCard = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!checkIdCard(value)) {
				callback(new Error("请输入正确的身份证号码"));
			} else {
				callback();
			}
		};
		var validateUrl = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isURL(value)) {
				callback(new Error("请输入正确的URL地址"));
			} else {
				callback();
			}
		};
		var validateMobile = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isMobile(value)) {
				callback(new Error("请输入正确的手机号码"));
			} else {
				callback();
			}
		};
		var validatePhone = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isPhone(value)) {
				callback(new Error("请输入正确的电话号码"));
			} else {
				callback();
			}
		};
		var validateEmail = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isEmail(value)) {
				callback(new Error("请输入正确的邮箱地址"));
			} else {
				callback();
			}
		};
		var validateNumber = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isNumber(value)) {
				callback(new Error("请输入数字"));
			} else {
				callback();
			}
		};
		var validateIntNumber = (rule, value, callback) => {
			if(!value){
				callback();
			} else if (!isIntNumer(value)) {
				callback(new Error("请输入整数"));
			} else {
				callback();
			}
		};
		return {
			logistics: true,
			id: '',
			type: '',
			submitLoading: false,
			previewVisible: false,
			previewImageUrl: '',
			
			
			ro:{
				orderid : false,
				tablename : false,
				userid : false,
				goodid : false,
				goodname : false,
				picture : false,
				buynumber : false,
				price : false,
				discountprice : false,
				total : false,
				discounttotal : false,
				type : false,
				status : false,
				address : false,
				tel : false,
				consignee : false,
				remark : false,
				logistics : false,
				goodtype : false,
			},
			
			
			ruleForm: {
				orderid: this.getUUID(),
				userid: '',
				goodid: '',
				goodname: '',
				picture: '',
				buynumber: '',
				status: '',
				address: '',
				tel: '',
				consignee: '',
				remark: '',
				logistics: '',
				goodtype: '',
			},
		
			typeOptions: [],
			statusOptions: [],
			
			rules: {
				orderid: [
					{ required: true, message: '订单编号不能为空', trigger: 'blur' },
				],
				tablename: [
				],
				userid: [
					{ required: true, message: '用户id不能为空', trigger: 'blur' },
				],
				goodid: [
					{ required: true, message: '商品id不能为空', trigger: 'blur' },
				],
				goodname: [
				],
				picture: [
				],
				buynumber: [
					{ required: true, message: '购买数量不能为空', trigger: 'blur' },
					{ validator: validateIntNumber, trigger: 'blur' },
				],
				price: [
					{ required: true, message: '价格不能为空', trigger: 'blur' },
					{ validator: validateNumber, trigger: 'blur' },
				],
				discountprice: [
					{ validator: validateNumber, trigger: 'blur' },
				],
				total: [
					{ required: true, message: '总价格不能为空', trigger: 'blur' },
					{ validator: validateNumber, trigger: 'blur' },
				],
				discounttotal: [
					{ validator: validateNumber, trigger: 'blur' },
				],
				type: [
					{ validator: validateIntNumber, trigger: 'blur' },
				],
				status: [
				],
				address: [
				],
				tel: [
				],
				consignee: [
				],
				remark: [
				],
				logistics: [
				],
				goodtype: [
				],
			}
		};
	},
	props: ["parent"],
	computed: {



	},
	created() {
	},
	methods: {
		
		// 下载
		download(file){
			window.open(`${file}`)
		},
		// 初始化
		init(id,type) {
			if (id) {
				this.id = id;
				this.type = type;
			}
			if(this.type=='info'||this.type=='else'){
				this.info(id);
			}else if(this.type=='logistics'){
				this.logistics=false;
				this.info(id);
			}else if(this.type=='cross'){
				var obj = this.$storage.getObj('crossObj');
				for (var o in obj){
						if(o=='orderid'){
							this.ruleForm.orderid = obj[o];
							this.ro.orderid = true;
							continue;
						}
						if(o=='tablename'){
							this.ruleForm.tablename = obj[o];
							this.ro.tablename = true;
							continue;
						}
						if(o=='userid'){
							this.ruleForm.userid = obj[o];
							this.ro.userid = true;
							continue;
						}
						if(o=='goodid'){
							this.ruleForm.goodid = obj[o];
							this.ro.goodid = true;
							continue;
						}
						if(o=='goodname'){
							this.ruleForm.goodname = obj[o];
							this.ro.goodname = true;
							continue;
						}
						if(o=='picture'){
							this.ruleForm.picture = obj[o];
							this.ro.picture = true;
							continue;
						}
						if(o=='buynumber'){
							this.ruleForm.buynumber = obj[o];
							this.ro.buynumber = true;
							continue;
						}
						if(o=='price'){
							this.ruleForm.price = obj[o];
							this.ro.price = true;
							continue;
						}
						if(o=='discountprice'){
							this.ruleForm.discountprice = obj[o];
							this.ro.discountprice = true;
							continue;
						}
						if(o=='total'){
							this.ruleForm.total = obj[o];
							this.ro.total = true;
							continue;
						}
						if(o=='discounttotal'){
							this.ruleForm.discounttotal = obj[o];
							this.ro.discounttotal = true;
							continue;
						}
						if(o=='type'){
							this.ruleForm.type = obj[o];
							this.ro.type = true;
							continue;
						}
						if(o=='status'){
							this.ruleForm.status = obj[o];
							this.ro.status = true;
							continue;
						}
						if(o=='address'){
							this.ruleForm.address = obj[o];
							this.ro.address = true;
							continue;
						}
						if(o=='tel'){
							this.ruleForm.tel = obj[o];
							this.ro.tel = true;
							continue;
						}
						if(o=='consignee'){
							this.ruleForm.consignee = obj[o];
							this.ro.consignee = true;
							continue;
						}
						if(o=='remark'){
							this.ruleForm.remark = obj[o];
							this.ro.remark = true;
							continue;
						}
						if(o=='logistics'){
							this.ruleForm.logistics = obj[o];
							this.ro.logistics = true;
							continue;
						}
						if(o=='goodtype'){
							this.ruleForm.goodtype = obj[o];
							this.ro.goodtype = true;
							continue;
						}
				}
				



















			}
			
			
			
                            this.typeOptions = "现金".split(',')
            this.statusOptions = "未支付,未发货,已完成,已取消,已退款,已发货".split(',')
			
		},
    // 多级联动参数

    info(id) {
      this.$http({
        url: `orders/info/${id}`,
        method: "get"
      }).then(({ data }) => {
        if (data && data.code === 0) {
        this.ruleForm = data.data;
        //解决前台上传图片后台不显示的问题
        let reg=new RegExp('../../../upload','g')//g代表全部
        				this.ruleForm.logistics = this.ruleForm.logistics.replace(reg,'http://ht.yiminkangjian.top/taoziyiyuan/upload');
        } else {
          this.$message.error(data.msg);
        }
      });
    },


    // 提交
    onSubmit() {












	if(this.ruleForm.picture!=null) {
		this.ruleForm.picture = this.ruleForm.picture.replace(new RegExp(this.$base.url,"g"),"");
	}



























var objcross = this.$storage.getObj('crossObj');

      //更新跨表属性
       var crossuserid;
       var crossrefid;
       var crossoptnum;
       if(this.type=='cross'){
                var statusColumnName = this.$storage.get('statusColumnName');
                var statusColumnValue = this.$storage.get('statusColumnValue');
                if(statusColumnName!='') {
                        var obj = this.$storage.getObj('crossObj');
                       if(statusColumnName && !statusColumnName.startsWith("[")) {
                               for (var o in obj){
                                 if(o==statusColumnName){
                                   obj[o] = statusColumnValue;
                                 }
                               }
                               var table = this.$storage.get('crossTable');
                             this.$http({
                                 url: `${table}/update`,
                                 method: "post",
                                 data: obj
                               }).then(({ data }) => {});
                       } else {
                               crossuserid=this.$storage.get('userid');
                               crossrefid=obj['id'];
                               crossoptnum=this.$storage.get('statusColumnName');
                               crossoptnum=crossoptnum.replace(/\[/,"").replace(/\]/,"");
                        }
                }
        }
       this.submitLoading = true;
       this.$refs["ruleForm"].validate(valid => {
         if (valid) {
		 if(crossrefid && crossuserid) {
			 this.ruleForm.crossuserid = crossuserid;
			 this.ruleForm.crossrefid = crossrefid;
			let params = { 
				page: 1, 
				limit: 10, 
				crossuserid:this.ruleForm.crossuserid,
				crossrefid:this.ruleForm.crossrefid,
			} 
			this.$http({ 
				url: "orders/page", 
				method: "get", 
				params: params 
			}).then(({ 
				data 
			}) => { 
				if (data && data.code === 0) { 
				       if(data.data.total>=crossoptnum) {
					     this.$message.error(this.$storage.get('tips'));
					       return false;
				       } else {
					 this.$http({
					   url: `orders/${!this.ruleForm.id ? "save" : "update"}`,
					   method: "post",
					   data: this.ruleForm
					 }).then(({ data }) => {
					   if (data && data.code === 0) {
					     this.$message({
					       message: "操作成功",
					       type: "success",
					       duration: 1500,
					       onClose: () => {
						 this.parent.showFlag = true;
						 this.parent.addOrUpdateFlag = false;
						 this.parent.ordersCrossAddOrUpdateFlag = false;
						 this.parent.search();
						 this.parent.contentStyleChange();
					       }
					     });
					   } else {
					     this.$message.error(data.msg);
					   }
					   this.submitLoading = false;
					 });

				       }
				} else { 
				  this.submitLoading = false;
				} 
			});
		 } else {
			 this.$http({
			   url: `orders/${!this.ruleForm.id ? "save" : "update"}`,
			   method: "post",
			   data: this.ruleForm
			 }).then(({ data }) => {
			   if (data && data.code === 0) {
			     this.$message({
			       message: "操作成功",
			       type: "success",
			       duration: 1500,
			       onClose: () => {
				 this.parent.showFlag = true;
				 this.parent.addOrUpdateFlag = false;
				 this.parent.ordersCrossAddOrUpdateFlag = false;
				 this.parent.search();
				 this.parent.contentStyleChange();
			       }
			     });
			   } else {
			     this.$message.error(data.msg);
			   }
			   this.submitLoading = false;
			 });
		 }
         } else {
           this.submitLoading = false;
         }
       });
    },
    // 获取uuid
    getUUID () {
      return new Date().getTime();
    },
    // 返回
    back() {
      this.parent.showFlag = true;
      this.parent.addOrUpdateFlag = false;
      this.parent.ordersCrossAddOrUpdateFlag = false;
      this.parent.contentStyleChange();
    },
    pictureUploadChange(fileUrls) {
	    this.ruleForm.picture = fileUrls;
    },
    previewImage(url) {
      this.previewImageUrl = url;
      this.previewVisible = true;
    },
    getPaymentTypeText(type) {
      if (type === 1) {
        return '现金';
                      } else if (type === 2) {
                    return '现金';
                }
      return '';
    }
  }
};
</script>
<style lang="scss" scoped>
	.amap-wrapper {
		width: 100%;
		height: 500px;
	}
	
	.search-box {
		position: absolute;
	}
	
	.el-date-editor.el-input {
		width: auto;
	}
	
	.orders-form-container {
		padding: 20px;
		background-color: #f5f7fa;
		border-radius: 8px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.page-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		margin-bottom: 20px;
		padding-bottom: 15px;
		border-bottom: 1px solid #ebeef5;

		.header-left {
			display: flex;
			align-items: center;

			.back-button {
				margin-right: 15px;
				color: #606266;
				font-size: 14px;
				cursor: pointer;
				transition: color 0.3s;

				&:hover {
					color: #409eff;
				}
			}

			.header-info {
				h1 {
					margin: 0 0 5px 0;
					font-size: 20px;
					color: #303133;
				}

				.breadcrumb {
					font-size: 14px;
					color: #909399;

					span {
						margin-right: 5px;
					}
				}
			}
		}

		.header-actions {
			display: flex;
			gap: 10px;
		}
	}

	.form-content {
		background-color: #fff;
		border-radius: 8px;
		padding: 20px;
		box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
	}

	.order-form {
		.form-section {
			margin-bottom: 25px;
			padding-bottom: 20px;
			border-bottom: 1px dashed #ebeef5;

			&:last-child {
				border-bottom: none;
				padding-bottom: 0;
			}

			.section-title {
				display: flex;
				align-items: center;
				margin-bottom: 15px;
				padding-left: 10px;
				position: relative;

				.title-icon {
					margin-right: 8px;
					color: #409eff;
					display: flex;
					align-items: center;
					justify-content: center;
					
					svg {
						width: 18px;
						height: 18px;
						fill: currentColor;
					}
				}

				span {
					font-size: 16px;
					font-weight: bold;
					color: #303133;
				}

				&::before {
					content: '';
					position: absolute;
					left: 0;
					top: 0;
					height: 100%;
					width: 4px;
					background-color: #409eff;
					border-radius: 2px;
				}
			}

			.form-item {
				margin-bottom: 15px;
				&:last-child {
					margin-bottom: 0;
				}
			}

			.form-row {
				display: flex;
				gap: 20px;
				margin-bottom: 15px;

				&:last-child {
					margin-bottom: 0;
				}
			}
		}
	}

	.input-wrapper {
		display: flex;
		align-items: center;
		margin-top: 5px;

		.input-field {
			display: flex;
			align-items: center;
			position: relative;

			.field-icon {
				margin-right: 8px;
				color: #909399;
				font-size: 18px;
			}

			.form-input {
				flex: 1;
				height: 40px;
				line-height: 40px;
				padding: 0 10px;
				border: 1px solid #dcdfe6;
				border-radius: 4px;
				outline: none;
				transition: border-color 0.3s;

				&:focus {
					border-color: #409eff;
				}
			}

			.readonly-indicator {
				position: absolute;
				right: 10px;
				top: 50%;
				transform: translateY(-50%);
				color: #909399;
				font-size: 14px;
			}
		}

		.field-tip {
			font-size: 12px;
			color: #909399;
			margin-left: 10px;
		}
	}

	.select-wrapper {
		.select-field {
			.field-icon {
				margin-right: 8px;
				color: #909399;
				font-size: 18px;
			}

			.form-select {
				flex: 1;
				height: 40px;
				line-height: 40px;
				padding: 0 10px;
				border: 1px solid #dcdfe6;
				border-radius: 4px;
				outline: none;
				transition: border-color 0.3s;

				&:focus {
					border-color: #409eff;
				}
			}
		}
	}

	.textarea-wrapper {
		.textarea-field {
			.field-icon {
				margin-right: 8px;
				color: #909399;
				font-size: 18px;
			}

			.form-textarea {
				flex: 1;
				padding: 10px;
				border: 1px solid #dcdfe6;
				border-radius: 4px;
				outline: none;
				transition: border-color 0.3s;
				resize: none;
				font-size: 14px;
				line-height: 1.5;

				&:focus {
					border-color: #409eff;
				}
			}
		}
	}

	.image-item {
		.image-upload-wrapper {
			border: 1px dashed #dcdfe6;
			border-radius: 4px;
			padding: 10px;
			text-align: center;
			cursor: pointer;
			transition: border-color 0.3s;

			&:hover {
				border-color: #409eff;
			}

			.upload-tips {
				margin-top: 10px;
				font-size: 12px;
				color: #909399;
			}
		}

		.image-preview {
			.image-gallery {
				display: flex;
				flex-wrap: wrap;
				gap: 10px;

				.preview-item {
					position: relative;
					width: 100px;
					height: 100px;
					border: 1px solid #ebeef5;
					border-radius: 4px;
					overflow: hidden;
					cursor: pointer;
					transition: transform 0.3s, box-shadow 0.3s;

					&:hover {
						transform: translateY(-3px);
						box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
					}

					.preview-img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}

					.image-actions {
						position: absolute;
						top: 5px;
						right: 5px;
						background-color: rgba(0, 0, 0, 0.5);
						border-radius: 50%;
						width: 24px;
						height: 24px;
						display: flex;
						align-items: center;
						justify-content: center;
						cursor: pointer;
						opacity: 0;
						transition: opacity 0.3s;

						&:hover {
							opacity: 1;
						}

						.el-icon-zoom-in {
							color: #fff;
							font-size: 16px;
						}
					}
				}
			}
		}

		.empty-image {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 20px 0;
			color: #909399;
			font-size: 14px;

			.el-icon-picture-outline {
				font-size: 40px;
				margin-bottom: 5px;
			}
		}
	}

	.content-item {
		.editor-wrapper {
			.content-editor {
				min-width: 200px;
				max-width: 600px;
				margin-top: 10px;
				border: 1px solid #dcdfe6;
				border-radius: 4px;
				overflow: hidden;
				box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.05);

				.w-e-toolbar {
					border-bottom: 1px solid #ebeef5;
					background-color: #f5f7fa;
				}

				.w-e-text-container {
					padding: 10px;
					border: 1px solid #ebeef5;
					border-top: none;
					border-radius: 0 0 4px 4px;
					background-color: #fff;
					min-height: 150px;
				}
			}

			.field-tip {
				margin-top: 10px;
				font-size: 12px;
				color: #909399;
			}
		}

		.content-preview {
			.content-html {
				padding: 10px;
				border: 1px solid #ebeef5;
				border-radius: 4px;
				background-color: #fff;
				min-height: 150px;
				font-size: 14px;
				line-height: 1.8;
				color: #303133;
				overflow-y: auto;
			}
		}

		.empty-content {
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			padding: 20px 0;
			color: #909399;
			font-size: 14px;

			.el-icon-document {
				font-size: 40px;
				margin-bottom: 5px;
			}
		}
	}

	.preview-dialog {
		.el-dialog__header {
			background-color: #f5f7fa;
			border-bottom: 1px solid #ebeef5;
		}

		.el-dialog__body {
			padding: 20px;
			text-align: center;
		}
	}
</style>
